import posthog from "posthog-js"

/**
 * Same logic as `lib/posthog-enabled.ts`, inlined here on purpose: importing that
 * module from this file caused Turbopack HMR to drop the shared module factory
 * (“module factory is not available”) in dev. Keep both copies in sync.
 */
function isPostHogEnabled(): boolean {
  if (process.env.NEXT_PUBLIC_ASTRA_SIGNUP_E2E === "1") return false
  if (process.env.NEXT_PUBLIC_POSTHOG_ENABLED !== "true") {
    return false
  }
  const token = process.env.NEXT_PUBLIC_POSTHOG_PROJECT_TOKEN?.trim()
  return Boolean(token)
}

export function phGetDistinctId(): string | null {
  if (!isPostHogEnabled()) return null
  const id = posthog.get_distinct_id?.()
  return typeof id === "string" && id.length > 0 ? id : null
}

export function phPostHogRequestHeaders(): Record<string, string> {
  const distinctId = phGetDistinctId()
  if (!distinctId) return {}
  return { "X-POSTHOG-DISTINCT-ID": distinctId }
}

export function phCapture(event: string, properties?: Record<string, unknown>) {
  if (!isPostHogEnabled()) return
  posthog.capture(event, properties)
}

export function phIdentify(distinctId: string, properties?: Record<string, unknown>) {
  if (!isPostHogEnabled()) return
  posthog.identify(distinctId, properties)
}

export function phCaptureException(err: unknown) {
  if (!isPostHogEnabled()) return
  posthog.captureException(err)
}

export function phReset() {
  if (!isPostHogEnabled()) return
  posthog.reset()
}

export function phOptOutCapturing() {
  if (!isPostHogEnabled()) return
  posthog.opt_out_capturing?.()
}

export function phOptInCapturing() {
  if (!isPostHogEnabled()) return
  posthog.opt_in_capturing?.()
}
